import { GetterTree } from 'vuex';
import { StudyCalendarEventState } from './state';
import RootState from '@/store/root_state';
import { CalendarEvent, CalendarEventType } from '@/models/undergrad/calendar-event.model';

const getters: GetterTree<StudyCalendarEventState, RootState> = {
  studyCalendarEvents: (state): CalendarEvent[] => {
    return state.studyCalendarEvents;
  },
  studyCalendarEventsLives: (state): CalendarEvent[] => {
    return state.studyCalendarEvents.filter(
      (calendarEvent: CalendarEvent) => calendarEvent.type === CalendarEventType.LIVE,
    );
  },
  isLoadingStudyCalendarEventData: (state): boolean => {
    return state.isLoadingStudyCalendarEventData;
  },
};

export default getters;
